/**
 * @typedef {Object} ScheduleTemplateParams
 * @property {string} id
 * @property {string} divId
 * @property {string} name
 * @property {Array} forms - Event type summaries (5 limit)
 * @property {Array} triggers - Schedule triggers (20 limit)
 * @property {Array} allowedGroups
 * @property {boolean} startDateOptional
 * @property {boolean} startTimeOptional
 * @property {number} [duration] - Duration in minutes
 * @property {boolean} durationReadonly
 * @property {string} timezone
 * @property {boolean} timezoneReadonly
 * @property {number} minUsers
 * @property {boolean} triggersFollowIndex
 * @property {string} userId
 * @property {Object} createdAt
 * @property {Object} updatedAt
 * @property {string} createdBy
 * @property {string} updatedBy
 */

class ScheduleTemplate {
  constructor({
    id,
    divId,
    name,
    forms = [],
    triggers = [],
    allowedGroups = [],
    startDateOptional = false,
    startTimeOptional = false,
    duration,
    durationReadonly = false,
    timezone,
    timezoneReadonly = false,
    minUsers = 1,
    triggersFollowIndex = false,
    userId,
    createdAt,
    updatedAt,
    createdBy,
    updatedBy,
  }) {
    this.id = id;
    this.divId = divId;
    this.name = name;
    this.forms = forms;
    this.triggers = triggers;
    this.allowedGroups = allowedGroups;
    this.startDateOptional = startDateOptional;
    this.startTimeOptional = startTimeOptional;
    this.duration = duration;
    this.durationReadonly = durationReadonly;
    this.timezone = timezone;
    this.timezoneReadonly = timezoneReadonly;
    this.minUsers = minUsers;
    this.triggersFollowIndex = triggersFollowIndex;
    this.userId = userId;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
    this.createdBy = createdBy;
    this.updatedBy = updatedBy;
  }

  /**
   * @param {Object} data - Firestore document data
   * @param {string} divId
   * @returns {ScheduleTemplate}
   */
  static fromFirestore(data, divId) {
    return new ScheduleTemplate({
      id: data.id,
      divId,
      name: data.name,
      forms: data.forms || [],
      triggers: data.triggers || [],
      allowedGroups: data.allowedGroups || [],
      startDateOptional: data.startDateOptional || false,
      startTimeOptional: data.startTimeOptional || false,
      duration: data.duration,
      durationReadonly: data.durationReadonly || false,
      timezone: data.timezone,
      timezoneReadonly: data.timezoneReadonly || false,
      minUsers: data.minUsers || 1,
      triggersFollowIndex: data.triggersFollowIndex || false,
      userId: data.userId,
      createdAt: data.createdAt,
      updatedAt: data.updatedAt,
      createdBy: data.createdBy,
      updatedBy: data.updatedBy,
    });
  }
}

export default ScheduleTemplate;